import { Component, OnInit, Input, ChangeDetectorRef, ViewRef, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { restore } from "../../assets/json/restoreTooltip.en";
import { Options } from "ngx-slider-v2";

import { FieldType } from "@ngx-formly/core";
import { AppStateService } from "src/app/core-module/services/app-state.service";
import { FormBuilder, FormControl, FormGroup, NgModel, Validators } from '@angular/forms';

import { Subject } from "rxjs";
import { AloAocStateService } from "../core-module/services/state/alo-aoc-state.service";
import { FeatureDataStateService } from "../core-module/services/state/feature-data-state.service";
import { FeatureDefaultsStateService } from "../core-module/services/state/feature-defaults-state.service";
@Component({
  standalone: false,
  selector: "app-lip",
  templateUrl: "./lip.component.html",
  styleUrls: ["./lip.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LipComponent extends FieldType implements OnInit, OnDestroy {
  @Input() field;
  formatVersion: LegacyAny;

  private isNotNullOrUndefined(value: LegacyAny): boolean {
    return value !== null && value !== undefined;
  }
  column: LegacyAny;
  properties: LegacyAny = [];
  defaultColor: boolean = true;
  inputError: LegacyAny = [];
  CurveSelection: LegacyAny;
  CurveSelectionVal: LegacyAny;
  ngModelval: LegacyAny = [];
  restoreText = restore;
  userSpecified: boolean = false;
  curveSurveyValues = {};
  dimLevelColumn = [];
  outputVoltageColumn = [];
  quickConfigvalue;
  quickConfigCustomCSS;
  setQuickConfig;
  fileResponse: LegacyAny;
  isEdited: LegacyAny;
  lipDefaultColor;
  lipCreateFile: boolean;
  lipForm: FormGroup;
  isInputPower100: boolean;
  isInputPower100andDim: boolean;
  showboth: boolean;
  unsubscribe = new Subject<void>();
  InputPower100Min: LegacyAny;
  InputPower100Max: LegacyAny;
  InputPowerDimMin: LegacyAny;
  InputPowerDimMax: LegacyAny;
  DimLevelMax: LegacyAny;
  DimLevelMin: LegacyAny;
  isExternalRset: LegacyAny;
  // Backward-compatible facade for legacy specs expecting `apiService`.
  apiService: LegacyAny;
  constructor(
    
    private ref: ChangeDetectorRef,
    private fb: FormBuilder,
    private changeDet: ChangeDetectorRef,
    private appState: AppStateService,
    private featureDefaults: FeatureDefaultsStateService,
    private featureData: FeatureDataStateService,
    private aloAoc: AloAocStateService
  ) {
    super();
    this.apiService = {
      getlipDefaultValue: this.featureDefaults.getlipDefaultValue,
      getlipData: this.featureData.getlipData,
      getquickConfig: this.aloAoc.getquickConfig,
      sendlipdata: (data: LegacyAny) => this.featureData.sendlipdata(data),
      lipEditedVal: (data: LegacyAny) => this.featureData.lipEditedVal(data),
      lipInputError: (data: LegacyAny) => this.featureData.lipInputError(data),
    };
    this.lipForm = this.fb.group({
      Options: new FormControl("", [Validators.required]),
    });
  }
  ngOnInit() {
    this.isEdited = false;
    this.column = this.field.requiredProperties;
    this.properties = this.field.properties;
    this.apiService.getlipDefaultValue.subscribe((response) => {
      if (response == "valid") {
        this.lipDefaultColor = true;
        this.resetDefaultlipValues();
      }
    });
    this.apiService.getlipData.subscribe((data) => {
      if (data) {
        this.ngModelval = data;
        this.checkdfault();
        this.checkInvalidValues();
      }
    });
    if (
      this.properties.Options.enum.includes(`Input power at 100% only`) &&
      this.properties.Options.enum.includes(`Input power at 100% and dim`) &&
      this.properties.Options.enum.length > 1
    ) {
      this.showboth = true;
      this.isInputPower100 = this.isInputPower100andDim = false;
    } else if (
      this.properties.Options.enum.includes(`Input power at 100% only`) &&
      this.properties.Options.enum.length < 2
    ) {
      this.isInputPower100 = true;
      this.showboth = false;
    } else if (
      this.properties.Options.enum.includes(`Input power at 100% and dim`) &&
      this.properties.Options.enum.length < 2
    ) {
      this.isInputPower100andDim = true;
      this.showboth = false;
    }
    this.ngModelval["InputPower100"] = this.ngModelval["InputPower1001"] =
      this.properties.InputPower100.default;
    this.InputPower100Min = this.properties.InputPower100.minimum;
    this.InputPower100Max = this.properties.InputPower100.maximum;
    if (this.isNotNullOrUndefined(this.properties.InputPowerDim.propertyDefault)) {
      this.ngModelval["InputPowerDim"] =
        this.properties.InputPowerDim.propertyDefault;
    } else {
      this.ngModelval["InputPowerDim"] = this.properties.InputPowerDim.default;
    }
    this.InputPowerDimMin = this.properties.InputPowerDim.minimum;
    this.InputPowerDimMax = this.properties.InputPowerDim.maximum;
    if (this.isNotNullOrUndefined(this.properties.DimLevel.propertyDefault)) {
      this.ngModelval["DimLevel"] = this.properties.DimLevel.propertyDefault;
    } else {
      this.ngModelval["DimLevel"] = this.properties.DimLevel.default;
    }
    this.DimLevelMin = this.properties.DimLevel.minimum;
    this.DimLevelMax = this.properties.DimLevel.maximum;
    if (this.properties.Options.default === `Input power at 100% only`) {
      this.lipForm.controls["Options"].setValue(`Input power at 100% only`);
      this.ngModelval["Options"] = `Input power at 100% only`;
    } else {
      this.lipForm.controls["Options"].setValue(`Input power at 100% and dim`);
      this.ngModelval["Options"] = `Input power at 100% and dim`;
    }
    const unSelectedFeat = this.appState.getUnSelectedFeatConfig();
    let isConfigEdited = false;
    let featIndex: number = 0;
    if (unSelectedFeat != null) {
      unSelectedFeat.forEach((element) => {
        if (element["featureName"].toString().toUpperCase() === "LIP") {
          isConfigEdited = true;
          this.fileResponse = {};
          const lipUnSelectedVal: LegacyAny = element["featureParameters"][0];
          this.addlipLoadedFeatureReadValues(lipUnSelectedVal);
          unSelectedFeat.splice(featIndex, 1);
          this.appState.setUnSelectedFeatConfig(unSelectedFeat);
        } else {
          featIndex++;
        }
      });
    }

    if (!isConfigEdited) {
      // Set fileResponse to the configuration data for compatibility
      const configData = this.appState.getConfigurationData();
      this.fileResponse = configData;
      
      // Use centralized method to get feature data
      // This automatically prioritizes SaveSetData over ConfigurationData
      const lipData = this.appState.getFeatureData('LIP');
      if (lipData) {
        this.addlipLoadedFeatureReadValues(lipData);
      }
    }

    this.apiService.getquickConfig.subscribe((data) => {
      if (data === "quickConfig") {
        this.quickConfigvalue = true;
        this.quickConfigCustomCSS = "quick-custom-inputbox";
        this.setQuickConfig = "quickConfig";
      } else {
        this.quickConfigvalue = false;
        this.quickConfigCustomCSS = "custom-inputbox";
        this.setQuickConfig = "standard";
      }
      setTimeout(() => {
        if (this.ref && !(this.ref as ViewRef).destroyed) {
          this.ref.detectChanges();
        }
      });
    });
    this.sendlipdata(this.ngModelval);
    this.isEdited = true;
  }
  addlipLoadedFeatureReadValues(lip: LegacyAny) {
    const lipObj = lip;
    const keys = Object.keys(lipObj);
    const values = Object.values(lipObj);
    const result = [];
    keys.forEach((key, i) => {
      result[key] = values[i];
      this.textValChanged(values[i], key, result["Options"]);
    });
    this.ngModelval = result;
    if (
      this.isNotNullOrUndefined(result["Options"]) &&
      result["Options"] === `Input power at 100% and dim`
    ) {
      this.ngModelval["InputPower1001"] = result["InputPower1001"]
        ? result["InputPower1001"]
        : result["InputPower100"];
      this.ngModelval["InputPower100"] = this.appState.getInputPower100()
        ? this.appState.getInputPower100()
        : this.properties.InputPower100.default;
    } else {
      this.ngModelval["InputPower1001"] = this.appState.getInputPower1001()
        ? this.appState.getInputPower1001()
        : this.properties.InputPower100.default;
      this.ngModelval["InputPower100"] = result["InputPower100"];
    }

    this.ngModelval["InputPowerDim"] = this.isNotNullOrUndefined(
      result["InputPowerDim"]
    )
      ? result["InputPowerDim"]
      : this.isNotNullOrUndefined(this.appState.getInputPowerDim())
      ? this.appState.getInputPowerDim()
      : this.properties.InputPowerDim.default;

    this.ngModelval["DimLevel"] = this.isNotNullOrUndefined(result["DimLevel"])
      ? result["DimLevel"]
      : this.isNotNullOrUndefined(this.appState.getDimLevel())
      ? this.appState.getDimLevel()
      : this.properties.DimLevel.default;

    if (
      this.isNotNullOrUndefined(result["Options"]) &&
      result.hasOwnProperty("Options")
    ) {
      this.ngModelval["Options"] = result["Options"];
      this.lipForm.controls["Options"].setValue(result["Options"]);
    }
    if (
      this.properties.Options.enum.includes(`Input power at 100% only`) &&
      this.properties.Options.enum.includes(`Input power at 100% and dim`) &&
      this.properties.Options.enum.length > 1
    ) {
      this.showboth = true;
      this.isInputPower100 = this.isInputPower100andDim = false;
    } else if (
      this.properties.Options.enum.includes(`Input power at 100% only`) &&
      this.properties.Options.enum.length < 2
    ) {
      this.isInputPower100 = true;
      this.showboth = false;
    } else if (
      this.properties.Options.enum.includes(`Input power at 100% and dim`) &&
      this.properties.Options.enum.length < 2
    ) {
      this.isInputPower100andDim = true;
      this.showboth = false;
    }
    this.checkdfault();
    this.checkInvalidValues();
    this.sendlipdata(this.ngModelval);
  }
  sendlipdata(val) {
    this.apiService.sendlipdata(val);
    if (this.isEdited) {
      this.setConfigurationData(this.ngModelval, "LIP");
    }
  }
  checkdfault() {
    this.lipDefaultColor = true;
    this.properties = this.field.properties;
    for (const type in this.ngModelval) {
      if (this.ngModelval[type] === "") {
        this.lipDefaultColor = false;
      }
      if (type == "InputPower100") {
        if (this.ngModelval[type] != this.properties[type]["default"]) {
          this.lipDefaultColor = false;
        }
      } else if (type == "InputPower1001") {
        if (
          this.ngModelval[type] != this.properties["InputPower100"]["default"]
        ) {
          this.lipDefaultColor = false;
        }
      } else if (type == "DimLevel") {
        if (
          this.isNotNullOrUndefined(this.properties[type]["propertyDefault"]) &&
          this.ngModelval[type] != this.properties[type]["propertyDefault"]
        ) {
          this.lipDefaultColor = false;
        } else if (
          this.isNotNullOrUndefined(this.properties[type]["default"]) &&
          this.ngModelval[type] != this.properties[type]["default"]
        ) {
          this.lipDefaultColor = false;
        }
      } else if (type == "InputPowerDim") {
        if (
          this.isNotNullOrUndefined(this.properties[type]["propertyDefault"]) &&
          this.ngModelval[type] != this.properties[type]["propertyDefault"]
        ) {
          this.lipDefaultColor = false;
        } else if (
          this.isNotNullOrUndefined(this.properties[type]["default"]) &&
          this.ngModelval[type] != this.properties[type]["default"]
        ) {
          this.lipDefaultColor = false;
        }
      } else if (type == "Options") {
        if (this.properties[type].hasOwnProperty("default")) {
          if (this.ngModelval[type] != this.properties[type]["default"]) {
            this.lipDefaultColor = false;
          }
        }
      }
    }
    this.apiService.lipEditedVal(this.lipDefaultColor);
  }
  checkInvalidValues() {
    this.lipCreateFile = false;
    for (const type in this.inputError) {
      if (this.inputError[type]) {
        this.lipCreateFile = true;
      }
    }
    this.apiService.lipInputError(this.lipCreateFile);
  }
  resetDefaultlipValues() {
    if (
      this.properties.hasOwnProperty("InputPower100") &&
      this.isNotNullOrUndefined(this.properties.InputPower100.propertyDefault)
    ) {
      this.ngModelval["InputPower100"] = this.ngModelval["InputPower1001"] =
        this.properties.InputPower100.propertyDefault;
    } else {
      this.ngModelval["InputPower100"] = this.ngModelval["InputPower1001"] =
        this.properties.InputPower100.default;
    }
    if (
      this.properties.hasOwnProperty("InputPowerDim") &&
      this.isNotNullOrUndefined(this.properties.InputPowerDim.propertyDefault)
    ) {
      this.ngModelval["InputPowerDim"] =
        this.properties.InputPowerDim.propertyDefault;
    } else {
      this.ngModelval["InputPowerDim"] = this.properties.InputPowerDim.default;
    }
    if (
      this.properties.hasOwnProperty("DimLevel") &&
      this.isNotNullOrUndefined(this.properties.DimLevel.propertyDefault)
    ) {
      this.ngModelval["DimLevel"] = this.properties.DimLevel.propertyDefault;
    } else {
      this.ngModelval["DimLevel"] = this.properties.DimLevel.default;
    }
    this.ngModelval["Options"] = this.properties.Options.default;
    if (this.properties.Options.default === `Input power at 100% and dim`) {
      this.lipForm.controls["Options"].setValue("Input power at 100% and dim");
    } else {
      this.lipForm.controls["Options"].setValue(`Input power at 100% only`);
    }
    for (const type in this.inputError) {
      this.inputError[type] = false;
    }
    this.lipCreateFile = false;
    this.apiService.lipInputError(this.lipCreateFile);
    this.sendlipdata(this.ngModelval);
  }
  setConfigurationData(value, keyVal) {
    if (this.isNotNullOrUndefined(value)) {
      // Use centralized method to save feature data
      // This automatically saves to both ConfigurationData and SaveSetData
      const lipObj = Object.assign({}, value);
      this.appState.setFeatureData(keyVal, lipObj);
    }
  }
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    return !(charCode > 31 && (charCode < 48 || charCode > 57));
  }
  numberOnlyWithDec(evt): boolean {
    const charCode = evt.which ? evt.which : evt.keyCode;
    if (
      charCode == 8 ||
      charCode == 13 ||
      charCode == 99 ||
      charCode == 118 ||
      charCode == 46
    ) {
      if (
        this.isNotNullOrUndefined(evt.target.value) &&
        evt.target.value.toString().match(/^\d*\.?\d{0,0}$/g)
      ) {
        return true;
      } else if (
        this.isNotNullOrUndefined(evt.key) &&
        evt.key.toString().match(/^\d*\.?\d{0,0}$/g)
      ) {
        return true;
      }
      return false;
    }

    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    if (
      this.isNotNullOrUndefined(evt.target.value) &&
      evt.target.value.toString().match(/^\d*\.?\d{0,0}$/g)
    ) {
      return true;
    } else if (
      this.isNotNullOrUndefined(evt.key) &&
      evt.key.toString().match(/^\d*\.?\d{0,0}$/g)
    ) {
      return true;
    }

    return false;
  }

  validateInputValue(value: LegacyAny) {
    value = value.toString();
    if (value === "" || value === "." || value === "..") {
      return true;
    } else if (value.includes(".")) {
      const count = value.split(".").length - 1;
      return count > 1;
    } else {
      return false;
    }
  }

  textValChanged(value, colName, options?) {
    this.lipDefaultColor = false;
    this.inputError[colName] = false;
    this.lipCreateFile = false;
    if (colName == "InputPower100") {
      if (
        value < this.InputPower100Min ||
        value > this.InputPower100Max ||
        this.validateInputValue(value)
      ) {
        this.inputError[colName] = true;
        this.ngModelval["InputPower100"] = value;
      } else {
        this.ngModelval["InputPower100"] = value;
      }
    } else if (
      colName == "InputPower1001" ||
      (options === `Input power at 100% and dim` &&
        colName != "DimLevel" &&
        colName != "InputPowerDim")
    ) {
      if (
        value < this.InputPower100Min ||
        value > this.InputPower100Max ||
        value.length <= 0 ||
        parseFloat(value) < parseFloat(this.ngModelval["InputPowerDim"])
      ) {
        this.inputError[colName] = true;
        this.ngModelval["InputPower1001"] = value;
      } else {
        this.inputError["InputPower1001"] = false;
        this.ngModelval["InputPower1001"] = value;
      }
    } else if (colName == "InputPowerDim") {
      if (
        value < this.InputPowerDimMin ||
        value > this.InputPowerDimMax ||
        parseFloat(value) > parseFloat(this.ngModelval["InputPower1001"]) ||
        value.length <= 0
      ) {
        this.inputError[colName] = true;
        this.ngModelval["InputPowerDim"] = value;
      } else {
        this.inputError["InputPowerDim"] = false;
        this.ngModelval["InputPowerDim"] = value;
      }
    } else if (colName == "DimLevel") {
      if (
        value < this.DimLevelMin ||
        value > this.DimLevelMax ||
        value.length <= 0
      ) {
        this.inputError[colName] = true;
        this.ngModelval["DimLevel"] = value;
      } else {
        this.inputError[colName] = false;
        this.ngModelval["DimLevel"] = value;
      }
    }
    this.changeDet.detectChanges();
    this.checkdfault();
    for (const type in this.inputError) {
      if (this.inputError[type]) {
        this.lipCreateFile = true;
      }
    }
    this.checkInvalidValues();
    this.apiService.lipEditedVal(this.lipDefaultColor);
    this.apiService.lipInputError(this.lipCreateFile);
    this.sendlipdata(this.ngModelval);
  }
  handleChange(eventVal) {
    this.ngModelval["Options"] = eventVal.target.value;
    this.sendlipdata(this.ngModelval);
  }
  ngOnDestroy() {
    this.unsubscribe.next(undefined);
  }
}

